import { render } from "./ApplyDetail.vue?vue&type=template&id=18a1cb0c&scoped=true"
import script from "./ApplyDetail.vue?vue&type=script&lang=js"
export * from "./ApplyDetail.vue?vue&type=script&lang=js"

import "./ApplyDetail.vue?vue&type=style&index=0&id=18a1cb0c&scoped=true&lang=css"

import exportComponent from "/home/web/vina_user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18a1cb0c"]])

export default __exports__